import * as stylex from '@stylexjs/stylex'
import { ButtonBase } from '../ButtonBase/ButtonBase'
import { ArrowLeftLarge, ArrowRightLarge } from '../Icons'
import { type MobileMediaQuery } from '../tokens/breakpoints.stylex'
import { colors } from '../tokens/colors.stylex'
import { useXStyles, type XStyles } from '../useXStyles/useXStyles'
import { useCarousel } from './useCarousel'

const MOBILE: MobileMediaQuery = '@media (max-width: 480px)'

const _baseStyles = stylex.create({
  button: {
    borderColor: colors.white,
    borderRadius: '50%',
    borderStyle: 'solid',
    borderWidth: 1,
    transition: 'all 0.2s',
    alignItems: 'center',
    backgroundColor: {
      'default': 'transparent',
      ':hover': 'rgba(0, 0, 0, 0.10)',
    },
    color: colors.white,
    display: {
      [MOBILE]: 'none',
      default: 'flex',
    },
    justifyContent: 'center',
    opacity: 0,
    pointerEvents: 'none',
    height: 32,
    width: 32,
  },
  fadeIn: {
    opacity: 1,
    pointerEvents: 'auto',
  },
  left: {
    position: 'absolute',
    transform: 'translate(0, -50%)',
    left: 12,
    top: '50%',
  },
  right: {
    position: 'absolute',
    transform: 'translate(0, -50%)',
    right: 12,
    top: '50%',
  },
})

export interface NavButtonsProps {
  xStyles?: Partial<XStyles<keyof typeof _baseStyles>>
  show?: boolean
}

export const NavButtons = (props: NavButtonsProps) => {
  const { xStyles, show } = props
  const { currentPage, totalPages, wrapMode, goBack, goForward } = useCarousel()
  const baseStyles = useXStyles(_baseStyles, xStyles)

  const allowWrap = wrapMode !== 'nowrap'

  const enablePrevNavButton = allowWrap || currentPage > 0
  const enableNextNavButton = allowWrap || currentPage < totalPages - 1

  return (
    <>
      <ButtonBase
        rootStyle={[baseStyles.button, baseStyles.left, show && baseStyles.fadeIn]}
        onClick={goBack}
        disabled={!enablePrevNavButton}
      >
        <ArrowLeftLarge />
      </ButtonBase>
      <ButtonBase
        rootStyle={[baseStyles.button, baseStyles.right, show && baseStyles.fadeIn]}
        onClick={goForward}
        disabled={!enableNextNavButton}
      >
        <ArrowRightLarge />
      </ButtonBase>
    </>
  )
}
